<template>
  <main :id="$style.main">
    <main-title
      :class="$style.main_title"
      :main_title="'松井秀喜情報'"
      :sub_title="'〜 Hideki Matsui Information 〜'"
      :color="'#403f3f'"
      :align="'center'"
    ></main-title>
    <basic-info-visual />
    <history-visual />
    <all-score-visual />
    <homerun-info-visual />
  </main>
</template>

<script lang="ts">
import Vue from "vue";
import MainTitle from "@/components/atoms/MainTitle.vue";
import BasicInfoVisual from "@/components/organsms/hideki_info/BasicInfoVisual.vue";
import HistoryVisual from "@/components/organsms/hideki_info/HistoryVisual.vue";
import AllScoreVisual from "@/components/organsms/hideki_info/AllScoreVisual.vue";
import HomerunInfoVisual from "@/components/organsms/hideki_info/HomerunInfoVisual.vue";

export default Vue.extend({
  name: "HidekiInfoView",

  components: {
    MainTitle,
    BasicInfoVisual,
    HistoryVisual,
    AllScoreVisual,
    HomerunInfoVisual
  }
});
</script>

<style lang="scss" module>
@import "../../assets/style/base.scss";

@media only screen and (max-width: 1023px) {
  #main {
    background-color: #fddea2;
    section {
      margin: 40px 0px;
    }
  }
}
@media only screen and (min-width: 1024px) {
  #main {
    background-color: #fddea2;
    .main_title {
      text-align: center;
    }
    section {
      padding: 120px 0px;
    }
  }
}
</style>
